import React from "react";
import moment from "moment";
import {
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaCcVisa,
  FaCcMastercard,
  FaBarcode,
} from "react-icons/fa";
import { IoLocationSharp, IoCall, IoMail } from "react-icons/io5";
import { FaPix } from "react-icons/fa6";

const Footer = () => {
  const navigationLinks = [
    { name: "Sobre a Flitz", href: "/sobre-nos" },
    { name: "Privacidade", href: "/politica-de-privacidade" },
    { name: "Termos & Condições", href: "/termos-e-condicoes" },
    { name: "Trocas & Devoluções", href: "/politica-de-trocas-e-devolucoes" },
  ];

  const socialLinks = [
    { href: "https://facebook.com", icon: <FaFacebook /> },
    { href: "https://www.instagram.com/flitz.am?igsh=MW8zZHFpOTc0MDdpdw==", icon: <FaInstagram /> },
    { href: "https://twitter.com", icon: <FaTwitter /> },
  ];

  const paymentIcons = [
    { icon: FaCcVisa, name: "Visa" },
    { icon: FaCcMastercard, name: "Mastercard" },
    { icon: FaBarcode, name: "Boleto" },
    { icon: FaPix, name: "Pix" },
  ];

  return (
    <footer className="bg-zinc-900 text-zinc-100 py-12 px-6 md:px-16">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
        {/* Navegação */}
        <nav className="space-y-4">
          <h4 className="text-lime-400 text-lg font-bold uppercase tracking-wide">Flitz</h4>
          <ul className="space-y-2 text-sm">
            {navigationLinks.map((link, index) => (
              <li key={index}>
                <a
                  href={link.href}
                  className="hover:text-lime-400 transition-colors duration-200"
                >
                  {link.name}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        {/* Contato */}
        <address className="not-italic space-y-4 text-sm">
          <h4 className="text-lime-400 font-semibold uppercase tracking-wide">Atendimento</h4>
          <ul className="space-y-2">
            <li className="flex items-center">
              <IoCall className="mr-2 text-lime-400" />
              <span>(95) 99127-3913</span>
            </li>
            <li className="flex items-center">
              <IoMail className="mr-2 text-lime-400" />
              <span>contato@flitz.com.br</span>
            </li>
            <li className="flex items-center">
              <IoLocationSharp className="mr-2 text-lime-400" />
              <span>
                Av. Nazaré Filgueiras, 2426A<br />Pintolândia - Boa Vista/RR
              </span>
            </li>
          </ul>
        </address>

        {/* Pagamentos & Redes */}
        <div className="space-y-4 text-sm">
          <h4 className="text-lime-400 font-semibold uppercase tracking-wide">Pagamento Seguro</h4>
          <div className="flex items-center space-x-4">
            {paymentIcons.map((method, i) => {
              const Icon = method.icon;
              return <Icon key={i} size={28} className="text-zinc-400 hover:text-lime-400" />;
            })}
          </div>
          <p className="text-xs text-zinc-400 mt-2">Via Mercado Pago com proteção SSL</p>

          <div className="mt-6">
            <h4 className="text-lime-400 font-semibold mb-2 uppercase tracking-wide">Redes</h4>
            <div className="flex space-x-4">
              {socialLinks.map((social, i) => (
                <a
                  key={i}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-zinc-400 hover:text-lime-400 transition"
                  aria-label={`Siga no ${social.icon.type.displayName}`}
                >
                  {React.cloneElement(social.icon, { size: 24 })}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Rodapé */}
      <div className="mt-12 border-t border-zinc-700 pt-4 text-center text-xs text-zinc-500">
        <p>
          &copy; {moment().format("YYYY")} Flitz Brasil • CNPJ 49.793.315/0001-22 • Todos os direitos reservados.
        </p>
      </div>
    </footer>
  );
};

export default Footer;